import { render, staticRenderFns } from "./vastuuhenkilon-arvio-card.vue?vue&type=template&id=7bd6de2b&"
import script from "./vastuuhenkilon-arvio-card.vue?vue&type=script&lang=ts&"
export * from "./vastuuhenkilon-arvio-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports